import React, { FunctionComponent, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux';
import { Article, RootStore } from '../app/types';
import './ArticleFull.css';

export const ArticleFull: FunctionComponent = () => {
    const { articleID } = useParams();
    const articleIdNum = parseInt(articleID);

    const articles = useSelector((state: RootStore) => state.articles);

    const article = useMemo(() =>
        articles.find((a: Article) => a.ID === articleIdNum) ?? null,
        [articles, articleIdNum]
    );

    return article ? <div>
        <div className="article-body">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {article.content}
            </ReactMarkdown>
        </div >
    </div> : <div/>;
}
